module.exports = __webpack_public_path__ + "5dfd2441dfd39e93dcca9e0553744f0b.pdf";